import React from "react";
import "./styles.css";

const PromptCard = ({ prompt, onClick }) => {
  return (
    <div className="card-container">
      <div className="card" onClick={() => onClick(prompt)}>
        {prompt}
      </div>
    </div>
  );
};
export default PromptCard;
